(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beylora-c-plp-head"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var CELL_SELECTOR = '.product-grid .product-grid__item';
    var WAVE_STEP_MS = 70; /* stagger between cells revealed in one wave */
    var WAVE_CAP_MS = 420; /* deep waves never feel slow */

    function initBeyloraCPlpStage() {
      var reduced = false;
      try {
        reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}
      if (reduced || !('IntersectionObserver' in window)) return;

      var cells = Array.prototype.filter.call(
        document.querySelectorAll(CELL_SELECTOR),
        function (cell) {
          return !cell.classList.contains('beylora-c-plp-cell-armed');
        }
      );
      if (!cells.length) return;

      var io = new IntersectionObserver(
        function (entries) {
          var wave = [];
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) wave.push(entries[i].target);
          }
          if (!wave.length) return;
          wave.sort(function (a, b) {
            /* DOM order, so a wave staggers left-to-right, row by row */
            return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
          });
          for (var j = 0; j < wave.length; j++) {
            var delay = Math.min(j * WAVE_STEP_MS, WAVE_CAP_MS);
            wave[j].style.setProperty('--beylora-c-plp-cell-d', delay + 'ms');
            wave[j].classList.add('beylora-c-plp-cell-in');
            io.unobserve(wave[j]);
          }
        },
        { threshold: 0.08, rootMargin: '0px 0px -4% 0px' }
      );

      for (var k = 0; k < cells.length; k++) {
        cells[k].classList.add('beylora-c-plp-cell-armed');
        io.observe(cells[k]);
      }
    }

    initBeyloraCPlpStage();
    document.addEventListener('shopify:section:load', function () {
      initBeyloraCPlpStage();
    });
  })();

  /* About row on ring collections (D16): move it from the head to just after the product grid's section, so the
     first screen is rings and prices. It sits outside the section that filter changes re-render, so it stays put.
     If the grid is not found it is shown where it is. */
  (function () {
    function moveAbout() {
      try {
        var pending = document.querySelector('.beylora-c-plp-head__about[data-bey-about="pending"]');
        if (!pending) return;
        var grid = document.querySelector('.product-grid');
        var host = grid && grid.closest('.shopify-section');
        if (!host || !host.parentNode) { pending.setAttribute('data-bey-about', 'moved'); return; }
        var old = document.querySelectorAll('.beylora-c-plp-head__about[data-bey-about="moved"]');
        for (var i = 0; i < old.length; i++) old[i].remove();
        host.parentNode.insertBefore(pending, host.nextSibling);
        pending.setAttribute('data-bey-about', 'moved');
      } catch (e) {
        var p = document.querySelector('.beylora-c-plp-head__about[data-bey-about="pending"]');
        if (p) p.setAttribute('data-bey-about', 'moved');
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moveAbout);
    else moveAbout();
    document.addEventListener('shopify:section:load', moveAbout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beylora-product-romance"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ------------------------------------------------------------
       Presence cells: a visual MIRROR — taps drive only the
       visualization, never the variant selection. Reveals, parallax
       and masked type are owned by the flow engine
       (assets/beylora-flow-20260612.js).
       ------------------------------------------------------------ */
    function initRomance(root) {
      if (root.dataset.beyloraCPdpInit === 'true') return;
      root.dataset.beyloraCPdpInit = 'true';

      var cells = root.querySelectorAll('.beylora-c-pdp-presence__cell');
      function activate(cell) {
        cells.forEach(function (c) {
          var on = c === cell;
          c.classList.toggle('beylora-c-pdp-presence__cell--active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      cells.forEach(function (cell) {
        cell.addEventListener('click', function () {
          activate(cell);
        });
        cell.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activate(cell);
          }
        });
      });

      var turnBox = root.querySelector('[data-beylora-c-turn]');
      if (turnBox) initTurn(turnBox);
    }

    /* ------------------------------------------------------------
       The 360 turn — real staged frames, canvas, drag + touch +
       keyboard scrub. Lazy: nothing beyond the still loads until the
       band approaches the viewport or she shows intent. Reduced
       motion or no-canvas: the still first frame stands alone.
       ------------------------------------------------------------ */
    function initTurn(box) {
      if (box.dataset.beyloraCTurnInit === 'true') return;
      box.dataset.beyloraCTurnInit = 'true';

      var stage = box.closest('.beylora-c-pdp-turn__stage') || box.parentElement;
      var hint = stage ? stage.querySelector('[data-beylora-c-turn-hint]') : null;
      var canvas = box.querySelector('.beylora-c-pdp-turn__canvas');
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ctx = canvas && canvas.getContext ? canvas.getContext('2d') : null;

      if (reduced || !ctx || !window.requestAnimationFrame) {
        /* static first frame: strip the interactive contract entirely */
        ['role', 'tabindex', 'aria-label', 'aria-valuemin', 'aria-valuemax', 'aria-valuenow', 'aria-valuetext']
          .forEach(function (attr) {
            box.removeAttribute(attr);
          });
        box.style.cursor = 'auto';
        if (hint) hint.hidden = true;
        return;
      }

      var N = parseInt(box.dataset.frameCount, 10) || 96;
      var srcParts = (box.dataset.frameSrc || '').split('?');
      var srcBase = srcParts[0];
      var srcQuery = srcParts.length > 1 ? '?' + srcParts.slice(1).join('?') : '';

      function fileFor(i) {
        var n = String(i + 1);
        while (n.length < 3) n = '0' + n;
        return srcBase.replace('-001.webp', '-' + n + '.webp') + srcQuery;
      }

      var imgs = new Array(N);
      var ok = new Array(N);
      var pos = 0;
      var raf = 0;
      var lastDrawn = -1;
      var started = false;

      /* coarse pass first (every 8th frame), then the rest — the first
         drag feels alive before the full set lands */
      var order = [];
      var a;
      for (a = 0; a < N; a += 8) order.push(a);
      for (a = 0; a < N; a++) if (a % 8 !== 0) order.push(a);
      var cursor = 0;
      var inflight = 0;
      var MAXC = 6;

      function pump() {
        while (inflight < MAXC && cursor < order.length) {
          (function (i) {
            inflight++;
            var im = new Image();
            im.onload = function () {
              var ready = function () {
                ok[i] = true;
                imgs[i] = im;
                inflight--;
                if (lastDrawn < 0 || i === current()) schedule();
                pump();
              };
              if (im.decode) {
                im.decode().then(ready, ready);
              } else {
                ready();
              }
            };
            im.onerror = function () {
              inflight--;
              pump();
            };
            im.src = fileFor(i);
          })(order[cursor++]);
        }
      }

      function start() {
        if (started) return;
        started = true;
        pump();
      }

      function mod(n, m) {
        return ((n % m) + m) % m;
      }
      function current() {
        return mod(Math.round(pos), N);
      }
      function nearest(i) {
        if (ok[i]) return i;
        for (var k = 1; k < N; k++) {
          if (ok[mod(i + k, N)]) return mod(i + k, N);
          if (ok[mod(i - k, N)]) return mod(i - k, N);
        }
        return -1;
      }

      function render() {
        raf = 0;
        var i = nearest(current());
        if (i < 0) return;
        if (i === lastDrawn) {
          syncAria();
          return;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(imgs[i], 0, 0, canvas.width, canvas.height);
        lastDrawn = i;
        box.classList.add('beylora-c-pdp-turn__box--live');
        syncAria();
      }

      function syncAria() {
        var c = current() + 1;
        box.setAttribute('aria-valuenow', String(c));
        box.setAttribute('aria-valuetext', 'Frame ' + c + ' of ' + N);
      }

      function schedule() {
        if (!raf) raf = requestAnimationFrame(render);
      }

      function dismissHint() {
        if (hint && !hint.classList.contains('beylora-c-pdp-turn__hint--gone')) {
          hint.classList.add('beylora-c-pdp-turn__hint--gone');
        }
      }

      /* lazy: arm the loader as the band approaches, or on first intent */
      if ('IntersectionObserver' in window) {
        var hintTimer = 0;
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) start();
              if (entry.intersectionRatio >= 0.6 && hint && !hintTimer) {
                hintTimer = setTimeout(dismissHint, 6000);
              }
            });
          },
          { threshold: [0, 0.6], rootMargin: '320px 0px 320px 0px' }
        );
        io.observe(box);
      } else {
        start();
      }

      /* drag / touch scrub — touch-action: pan-y keeps vertical scroll hers */
      var dragging = false;
      var lastX = 0;
      box.addEventListener('pointerdown', function (event) {
        start();
        dragging = true;
        lastX = event.clientX;
        box.classList.add('beylora-c-pdp-turn__box--dragging');
        try {
          box.setPointerCapture(event.pointerId);
        } catch (err) {}
      });
      box.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var dx = event.clientX - lastX;
        lastX = event.clientX;
        pos -= dx * (N / Math.max(box.clientWidth, 1)) * 1.35;
        dismissHint();
        schedule();
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        box.addEventListener(ev, function () {
          dragging = false;
          box.classList.remove('beylora-c-pdp-turn__box--dragging');
        });
      });

      /* keyboard scrub */
      box.addEventListener('keydown', function (event) {
        var step = event.shiftKey ? 5 : 1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
          start();
          pos += step;
          dismissHint();
          schedule();
          event.preventDefault();
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
          start();
          pos -= step;
          dismissHint();
          schedule();
          event.preventDefault();
        } else if (event.key === 'Home') {
          pos = 0;
          schedule();
          event.preventDefault();
        }
      });
      box.addEventListener('focus', start);
    }

    function initAll() {
      document.querySelectorAll('.beylora-c-pdp-romance').forEach(initRomance);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
